import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as reportUrls from '../oldReportsUrls'
import moment from 'moment/moment'
import { API_CACHE_DURATION, paymentModeAll, urls } from '../../../common/constants'
import { paymentModesWithAll, paytypes, TOPAY_COD_RULE } from '../../../common/paymentsMode'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import LoaderModel from './loaderModel'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import useToken from '../../../helpers/useTokens'
import { GT_COMPANY_ID, PAYAL, TULSI_TRAVEL } from '../../../../helper/companyIdhardcode'
import { getcolumnDefs, summaryColumnDefs, summaryUserWiseColumnDefs, TOPAY_AS_COD_HEADER_MAP, TRANSACTION_LABEL_MAP } from './constants'
import { formatPaymentSummaryTable, formatUserWiseSummaryTable, getGrandTotals, groupDetailedTable } from './utilFucntions'
import { useSearchParams } from 'react-router-dom'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../common/loginDecode'

const transactionsData = [
  { Transactions: 'All', transactionId: 0 },
  { Transactions: 'Booking', transactionId: 1 },
  { Transactions: 'Delivery', transactionId: 2 },
  { Transactions: 'Refund', transactionId: 3 },
]
const ModesData = [0, 'B', 'D', 'R']
const reportViewData = [
  { view: 'Detailed', id: 0 },
  { view: 'Summary', id: 1 },
  { view: 'Summary-UserWise', id: 2 },
]
const UserWiseCollectionNew = () => {
    const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const reportName = 'User Wise Collection'

  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selBranch, setSelBranch] = useState()
  const [selUser, setSelUser] = useState([])
  const [userStatusList, setUserStatusList] = useState([])
  const [transaction, setTransaction] = useState(transactionsData[0])
  const [paymentMode, setPaymentMode] = useState(paymentModeAll)
  const [paymentModeData, setPaymentModeData] = useState([])
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [ownChildBranches, setOwnChildBranches] = useState([])
  const [ownChildUsers, setOwnChildUsers] = useState([])
  const [modal, setModal] = useAtom(modalAtom)
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)

  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights, AllowGroupofCompanies } = { ...roleRightsData }
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
  const UseToPayAsCOD = companySettings?.UseToPayAsCOD
  const IsConvCharge = companySettings?.IsConvCharge

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    AllowGroupofCompanies = +searchParams.get('AllowGroupofCompanies') || 0
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }

  const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, IsBranchAdmin, strBranchName, IsMTPLAdmin } =
    loginData

  const disableBtn = !(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin)

  const updatedPaymentModes = !UseToPayAsCOD
    ? paymentModesWithAll
    : paymentModesWithAll
        .map((item) => {
          if (item.typeId === paytypes.COD) return null
          const codName = TOPAY_COD_RULE[item.typeId]
          return codName ? { ...item, name: codName } : item
        })
        .filter(Boolean)

  const [paymentType, setPaymentType] = useState(updatedPaymentModes[0])

  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === intCompanyID) || ChildCompanyList[0]
      setSelCompany(defaultCompany)
    } else {
      setSelCompany({
        CompanyID: intCompanyID,
        CompanyName: strCompanyName,
      })
    }
  }, [AllowGroupofCompanies, ChildCompanyList, intCompanyID, strCompanyName])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID,
      }
      fetchChildCompanyList(body)
    }
  }, [fetchChildCompanyList, intCompanyID, intUserID])

  useEffect(() => {
    focusElemnt('UWFromDate')
  }, [])

  useEffect(() => {
    if (intUserID) {
      const branchData = {
        intUserID,
        intCompanyID,
        intIsActive: -1,
      }

      const fetchBranchAndUserData = async () => {
        setLoader(true)
        const [branchRes, userRes] = await Promise.all([
          GetRequestCachedV3(urls.getOwnAndChildBranchList, branchData, true, API_CACHE_DURATION),
          GetRequestCachedV3(urls.getOwnAndChildUsersList, branchData, true, API_CACHE_DURATION),
        ])
        setLoader(false)

        if (branchRes?.status === 'Success' && branchRes?.Data?.Table?.length > 0) {
          setOwnChildBranches(branchRes.Data.Table)
          setSelBranch(branchRes.Data.Table.find((val) => val.BranchID === intBranchID) || branchRes.Data.Table[0])
        } else {
          setAlert({ show: true, msg: branchRes?.ErrMessage })
          setOwnChildBranches([])
        }

        if (userRes?.status === 'Success' && userRes?.Data?.Table?.length > 0) {
          setOwnChildUsers(userRes.Data.Table)
          setSelUser(userRes.Data.Table.filter((val) => val.UserID === intUserID) || [])
        } else {
          setOwnChildUsers([])
          setAlert({ show: true, msg: userRes?.ErrMessage })
        }
      }

      fetchBranchAndUserData()
    }
  }, [intBranchID, intCompanyID, intUserID, setAlert, setLoader])
  useEffect(() => {
    if (selBranch?.BranchID) {
      const fetchPaymentModeData = async () => {
        setLoader(true)
        const res = await GetRequestCachedV3(urls.getMOFPayment, { intBranchID: selBranch.BranchID }, true, API_CACHE_DURATION)
        setLoader(false)

        if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
          setPaymentModeData([paymentModeAll, ...res.Data.Table])
        } else {
          setPaymentModeData([])
          setAlert({ show: true, msg: res?.ErrMessage })
        }
      }

      fetchPaymentModeData()
    }
  }, [selBranch?.BranchID, setAlert, setLoader])
  useEffect(() => {
    if (selUser.length) {
      setUserStatusList(
        selUser.map((val) => ({
          loaded: 0,
          data: [],
          UserID: val.UserID,
          UserName: val.UserName,
        }))
      )
    } else {
      setUserStatusList([])
    }
  }, [selUser])

  const getReportData = async (data) => {
    const res = await GetRequest(urls.getUserWiseCollection, data)
    if (res?.status === 'Success') {
      const updatedData = { ...res.Data }
      if (UseToPayAsCOD === 1 && Array.isArray(updatedData.Table)) {
        updatedData.Table = updatedData.Table.map((item) => ({
          ...item,
          TYPE: TOPAY_COD_RULE[item.PaymentTypeInt] || item.TYPE,
        }))
      }
      return updatedData
    } else {
      setAlert({ show: true, msg: res?.ErrMessage })
      return []
    }
  }
  const availableUsers = [
    { UserName: 'All Users', UserID: 0 },
    ...(ownChildUsers?.filter((val) => val?.BranchID === selBranch?.BranchID && val?.IsUserActive) || []),
  ]
  const isAllUsersSelected = availableUsers.length > 0 && selUser.length === availableUsers.length
  const selectedUsersText = !selUser.length ? '' : isAllUsersSelected ? 'All' : selUser.map((val) => val.UserName).join(', ')
  const reportUserLabel = selUser.length === 1 ? selUser[0].UserName : isAllUsersSelected ? 'All' : 'Selected Users'
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Collection Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Collection Date', textAlign: 'left' },
    { field: 'selBranch', header: 'Branch', textAlign: 'left' },
    { field: 'selUser', header: 'User', textAlign: 'left' },
    { field: 'transactionType', header: 'Transaction Type', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'paymentMode', header: 'Payment Mode', textAlign: 'left' },
    { field: 'selReportView', header: 'Report View', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selBranch: selBranch?.BranchName || '',
    selUser: selectedUsersText,
    transactionType: transaction?.Transactions || '',
    paymentType: paymentType?.name || '',
    paymentMode: paymentMode?.ModeName || '',
    selReportView: reportView?.view || '',
    dataType: 'entry',
  }
  const normalizeTableData = (rows = []) => rows.map((row) => (row?.dataType === 'header2' ? { ...row, dataType: 'header' } : row))

  const getMainHeader = (columns = []) =>
    columns.map((column) => {
      const header = column.headerName || column.header || ''
      return {
        ...column,
        header,
        exportHead: column.exportHead || header,
        align: column?.xlCol?.dataType === 'string' ? 'left' : 'right' || column.textAlign || column.align || 'left',
        weight: column?.weight ? column?.weight : 80,
      }
    })
  const getSummaryColumns = (columns = []) => {
    if (UseToPayAsCOD !== 1) return columns
    return columns
      .filter((column) => column.field !== 'CODAmt')
      .map((column) => ({
        ...column,
        header: TOPAY_AS_COD_HEADER_MAP[column.field] ?? column.header,
      }))
  }
  const generateReportRequest = (userId) => {
    return {
      CompanyID: selCompany?.CompanyID,
      BranchID: selBranch?.BranchID,
      UserID: userId,
      dtFrom: moment(fromDate).format('YYYY-MM-DD'),
      dtTo: moment(toDate).format('YYYY-MM-DD'),
      PaymentTypeIDs: paymentType?.typeId,
      Modes: ModesData[transaction?.transactionId],
      PaymentModeIDs: paymentMode?.ModeID,
    }
  }
  const openViewReport = (reportPayload, isPdf = false) => {
    if (isPdf) {
      downloadPDF({
        reportName: reportPayload.reportName,
        criteriaHeaders: reportPayload.criteriaHeaders,
        criteriaData: reportPayload.criteriaData,
        tableData: reportPayload.tableData,
        visibleColumns: reportPayload.mainHeader,
        loginData,
        hideHeader: reportPayload.hideHeader || false,
      })
      return
    }
    const rid = Date.now().toString()

    if (!window.generatedReports) {
      window.generatedReports = {}
    }

    window.generatedReports[rid] = reportPayload
    window.open(`/view-report?rid=${rid}`, '_blank')
  }
  const getReportUserDetail = (reportData) => {
    if (Array.isArray(reportData?.Table2) && reportData.Table2.length > 0) {
      return reportData.Table2
    }

    return [
      {
        Branchname: selBranch?.BranchName || '',
        Cityname: selBranch?.Cityname || selBranch?.CityName || '',
        Statename: selBranch?.Statename || selBranch?.StateName || '',
      },
    ]
  }
  const getReportPayload = (reportData) => {
    const userDetail = getReportUserDetail(reportData)

    if (reportView?.id === 1) {
      const activeSummaryColumns = getSummaryColumns(summaryColumnDefs)
      const grandTotals = getGrandTotals(reportData?.Table1 || [], activeSummaryColumns)
      const filteredHeaders = activeSummaryColumns.filter((col) => {
        if (['Transaction', 'TotalAmt', 'PaidAmt', 'TopayAmt', 'OnAccAmt'].includes(col.field)) {
          return true
        }
        return grandTotals[col.field] !== 0
      })
      const data = normalizeTableData(formatPaymentSummaryTable(reportData?.Table1 || [], reportUserLabel, userDetail, filteredHeaders))
      return {
        reportName: 'Userwise Collection Report (Summary)',
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: data,
        mainHeader: getMainHeader(filteredHeaders),
        hideHeader: true,
      }
    }

    if (reportView?.id === 2) {
      const activeSummaryUserWiseColumns = getSummaryColumns(summaryUserWiseColumnDefs)
      return {
        reportName: 'Userwise Collection Report (Summary-UserWise)',
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: normalizeTableData(
          formatUserWiseSummaryTable(reportData?.Table4 || [], reportUserLabel, userDetail, activeSummaryUserWiseColumns)
        ),
        mainHeader: getMainHeader(activeSummaryUserWiseColumns),
        hideHeader: true,
      }
    }

    const bookingColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.BKNG)
    const deliveryColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.DEL)
    const refundColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.RFND)

    return {
      reportName: 'Userwise Collection Report (Detailed)',
      criteriaHeaders,
      criteriaData: [criteriaData],
      tableData: normalizeTableData(
        groupDetailedTable(
          reportData?.Table || [],
          reportUserLabel,
          IsConvCharge,
          reportData?.Table3 || [],
          userDetail,
          bookingColumns,
          deliveryColumns,
          refundColumns
        )
      ),
      mainHeader: getMainHeader(bookingColumns),
      hideHeader: true,
      serialNokey: 'SN',
    }
  }
  const hasReportRows = (reportData) => {
    if (reportView?.id === 1) return Array.isArray(reportData?.Table1) && reportData.Table1.length > 0
    if (reportView?.id === 2) return Array.isArray(reportData?.Table4) && reportData.Table4.length > 0
    return Array.isArray(reportData?.Table) && reportData.Table.length > 0
  }
  const mergeUserReportData = (reportDataList = []) => {
    const { Table, Table1, Table3, Table4 } = reportDataList.reduce(
      (acc, curr) => {
        if (curr?.Table) acc.Table.push(...curr.Table)
        if (curr?.Table1) acc.Table1.push(...curr.Table1)
        if (curr?.Table3) acc.Table3.push(...curr.Table3)
        if (curr?.Table4) acc.Table4.push(...curr.Table4)
        return acc
      },
      { Table: [], Table1: [], Table3: [], Table4: [] }
    )
    const Table3Sum = Table3.reduce(
      (acc, item) => {
        acc.TotalConvCharge += parseFloat(item.TotalConvCharge) || 0
        acc.TotalLRs += parseFloat(item.TotalLRs) || 0
        acc.TotalUnis += parseFloat(item.TotalUnis) || 0
        return acc
      },
      {
        TotalConvCharge: 0,
        TotalLRs: 0,
        TotalUnis: 0,
      }
    )

    return {
      Table,
      Table1,
      Table2: reportDataList.find((item) => Array.isArray(item?.Table2) && item.Table2.length > 0)?.Table2 || [],
      Table3: [Table3Sum],
      Table4,
    }
  }
  const validateFilters = () => {
  const diffDays = Math.abs(toDate.diff(fromDate, 'days'))

  if (!selBranch?.BranchID) {
    setAlert({ show: true, msg: 'Select Branch', nextId: '' })
    return false
  }

  if (!selUser.length) {
    setAlert({ show: true, msg: 'Select Company User', nextId: '' })
    return false
  }

  if (selUser.length === 1 && diffDays > 31) {
    setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: ''})
    return false
  }

  if (selUser.length > 1 && diffDays > 15) {
    setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: ''})
    return false
  }
  return true
}
  const handleClick2 = () => {
    if (!validateFilters()) return

    let url = reportUrls.userWiseCollection
    const urlData = reportUrls.userWiseCollectionParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDt = fromDate.format('YYYY-MM-DD')
    urlData.ToDt = toDate.format('YYYY-MM-DD')
    urlData.BranchID = selBranch.BranchID
    urlData.UserID = selUser[0].UserID
    urlData.Summary = reportView?.id
    urlData.TransType = transaction.transactionId
    urlData.PaymentMode = paymentMode?.ModeID
    urlData.intCargoParentCompanyID = intCompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleClick1 = async (isPdf = false) => {
    if (!validateFilters()) return

    if (selUser.length === 1 || selUser[0].UserID === 0) {
      setLoader(true)
      const reportData = await getReportData(generateReportRequest(selUser[0].UserID))
      setLoader(false)
      if (!hasReportRows(reportData)) {
        setAlert({ show: true, msg: 'No Data found' })
        return
      }
      openViewReport(getReportPayload(reportData), isPdf)
      return
    }

    setModal('loaderModal')
    const reportDataList = []

    for (let i = 0; i < selUser.length; i++) {
      const userId = selUser[i].UserID
      setUserStatusList((prevList) => prevList.map((item) => (item.UserID === userId ? { ...item, loaded: 1 } : item)))
      const reportData = await getReportData(generateReportRequest(userId))
      setUserStatusList((prevList) => prevList.map((item) => (item.UserID === userId ? { ...item, loaded: 2 } : item)))
      reportDataList.push(reportData)
    }

    setModal()
    let mergedReportData = mergeUserReportData(reportDataList)
    if (!hasReportRows(mergedReportData)) {
      setAlert({ show: true, msg: 'No Data found' })
      return
    }
    openViewReport(getReportPayload(mergedReportData), isPdf)
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelBranch({ BranchName: strBranchName, BranchID: intBranchID })
    setSelUser([])
    setTransaction(transactionsData[0])
    setPaymentType(updatedPaymentModes?.[0])
    setPaymentMode(paymentModeAll)
    setReportView(reportViewData?.[0])
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && (
            <Item sx={sx.itemsxGrow}>
              <DropDownOA
                id={id.selectCompnay}
                label={lb.select_company}
                data={ChildCompanyList}
                defaultvalue={selCompany?.CompanyName}
                disabled={AllowGroupofCompanies === 1 ? false : true}
                onSelect={(e) => {
                  setSelCompany(e)
                }}
                dataKey={`CompanyName`}
                idKey={`CompanyID`}
                width="100%"
              />
            </Item>
          )}
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={lb.from_collection_date}
              id={'UWFromDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('UWToDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.to_collection_date}
              value={toDate}
              id={'UWToDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(id.selBranch)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.select_branch}
              id={id.selBranch}
              data={
                AllowViewAllBranchOfCityReport === 1 && AllowViewAllBranchReport === 0
                  ? ownChildBranches.filter((val) => val.CityID === intBranchCityID)
                  : ownChildBranches || []
              }
              defaultvalue={(ownChildBranches?.length > 0 && selBranch?.BranchName) || ''}
              disabled={disableBtn && AllowViewAllBranchOfCityReport === 0}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => {
                setSelBranch(val)
                setSelUser([])
              }}
              width="100%"
              nextId={id.userLIst}
              prevId={'UWToDate'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownMultiSelectV2
              id={id.userLIst}
              label={'Branch User'}
              defaultvalue={selUser}
              data={availableUsers}
              dataKey={`UserName`}
              idKey={`UserID`}
              onSelect={(list) => {
                setSelUser(list)
              }}
              HasAllSelect={true}
              width={isFromUrl ? '100%' : 'auto'}
              nextId={'UWTransaction'}
              prevId={id.selBranch}
              disabled={[GT_COMPANY_ID, PAYAL, TULSI_TRAVEL].includes(intCompanyID) ? false : disableBtn && AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '170px' }}>
            <DropDownOA
              id={'UWTransaction'}
              defaultvalue={transaction?.Transactions}
              data={transactionsData}
              width="100%"
              searchPlaceholder={`Search Transactions`}
              label={'Transaction Type'}
              tabIndex="2"
              dataKey={`Transactions`}
              idKey={`transactionId`}
              onSelect={(value) => {
                setTransaction(value)
              }}
              nextId={'UWPaymentType'}
              prevId={id.userLIst}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '175px' }}>
            <DropDownOA
              id="UWPaymentType"
              data={updatedPaymentModes}
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
              }}
              nextId={'UWPaymentMode'}
              prevId={'UWTransaction'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '270px' }}>
            <DropDownOA
              id="UWPaymentMode"
              data={paymentModeData}
              defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
              width="100%"
              searchPlaceholder={`Search By Payment Mode`}
              label={'Payment Mode'}
              tabIndex="2"
              dataKey={`ModeName`}
              idKey={`ModeID`}
              onSelect={(value) => {
                setPaymentMode(value)
              }}
              nextId={'UWReportView'}
              prevId={'UWPaymentType'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '268px' }}>
            <DropDownOA
              id="UWReportView"
              defaultvalue={reportView?.view}
              data={DefaultCurrencyID === 2 ? reportViewData.filter((val) => val.id !== 2) : reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => {
                setReportView(value)
              }}
              nextId={'UWSplitButton'}
              prevId={'UWPaymentMode'}
            />
          </Item>
          {isFromUrl ? (
            <Button
              variant="contained"
              sx={{ width: '100%', height: '40px' }}
              className="btn btn-primary"
              onClick={() => handleClick1(true)}
              id1={'UWSplitButton'}
            >
              DOWNLOAD PDF
            </Button>
          ) : (
            <>
              <Item
                sx={sx.itemsx}
                style={{ cursor: 'pointer' }}
                onKeyDown={(e) => navigation3(e, 'UWFromDate', 'UWReportView', () => handleClick1())}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  id1={'UWSplitButton'}
                  prevID={id.summaryCheck}
                  onClick1={() => handleClick1()}
                  onClick2={handleClick2}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                <RefreshSvg width={'24px'} height={'24px'} />
              </Item>
            </>
          )}
        </Box>
      </Item>
      {modal === 'loaderModal' && <LoaderModel list={userStatusList} />}
    </>
  )
}
export default UserWiseCollectionNew
